import { computed } from "vue";
import {} from "@/api/fileSources";
import { useFileSourceInstancesStore } from "@/stores/fileSourceInstancesStore";
import { useFileSourceTemplatesStore } from "@/stores/fileSourceTemplatesStore";
export function useInstanceAndTemplate(instanceIdRef) {
    const fileSourceTemplatesStore = useFileSourceTemplatesStore();
    const fileSourceInstancesStore = useFileSourceInstancesStore();
    fileSourceInstancesStore.fetchInstances();
    fileSourceTemplatesStore.fetchTemplates();
    const instance = computed(() => fileSourceInstancesStore.getInstance(instanceIdRef.value) || null);
    const template = computed(() => {
        var _a, _b;
        return instance.value
            ? fileSourceTemplatesStore.getTemplate((_a = instance.value) === null || _a === void 0 ? void 0 : _a.template_id, (_b = instance.value) === null || _b === void 0 ? void 0 : _b.template_version)
            : null;
    });
    return { instance, template };
}
